<template>
  <div class="nav">
    <div class="navMain">
      <div class="left">
        <img src="@/assets/images/icon.png" alt />
      </div>
      <div class="right">
        <div class="navItem" @click="scrollToElement('about')">
          <div>关于我们</div>
        </div>
        <div class="navItem haveChild">
          <div @click="scrollToElement('jiaoxue')">阿基实验室</div>
          <div class="box">
            <div
              @click="scrollToElement(item.id)"
              class="itemChild"
              v-for="item in childList"
              :key="item.id"
            >{{item.name}}</div>
          </div>
        </div>
        <div class="navItem" @click="scrollToElement('contact')">
          <div>联系我们</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from 'vue'
export default {
  name: 'TopNav',
  setup(props, context) {
    const childList = reactive([
      { name: '教学管理系统', id: 'jiaoxue' },
      { name: '可视化系统', id: 'keshihua' },
      { name: '3D人格测评', id: '3D' },
      { name: '太极拳项目', id: 'taiji' },
      { name: '睡眠实验室', id: 'shuimian' },
      { name: '人脑装置', id: 'rennao' }
    ])
    function scrollToElement(id) {
      context.emit('scrollToElement', id)
    }
    return {
      childList,
      scrollToElement
    }
  }
}
</script>

<style lang="scss" scoped>
.nav {
  width: 100%;
  height: 80px;
  background: #171819;
  backdrop-filter: blur(10px);
  .navMain {
    width: 90%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      img {
        width: 33px;
        height: 35px;
      }
    }
    .right {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .navItem {
        font-family: PingFangSC, PingFang SC;
        font-size: 16px;
        color: #cacaca;
        cursor: pointer;
        position: relative;
        .box {
          position: absolute;
          top: 35px;
          left: -20px;
          width: 120px;
          height: 244px;
          background: #2a2a2a;
          box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.5);
          border-radius: 4px;
          display: none;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          .itemChild {
            width: 100%;
            height: calc(244px / 6);
            line-height: calc(244px / 6);
            font-family: PingFangSC, PingFang SC;
            font-size: 14px;
            color: #cacaca;
            text-align: center;
          }
          & .itemChild:first-child {
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
          }
          & .itemChild:last-child {
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
          }
          & .itemChild:hover {
            background: #333232;
          }
        }
        &.box:hover {
          display: block;
        }
      }
      & .navItem :hover {
        color: #f9fafb;
      }
      & .navItem.haveChild:hover .box {
        display: flex;
      }
      & .navItem.haveChild::after {
        content: '';
        display: inline-block;
        width: 80px;
        height: 50px;
        position: absolute;
        top: 0;
        left: 0;
      }
      & .navItem:not(:last-child) {
        margin-right: 112px;
      }
    }
  }
}
</style>